import { DEFAULT_SEGMENT_SIZE } from '../constants.js';

export const getLabelFromPosition = (
  startPosition: number,
  isSinglePointRange: boolean,
  isFirstItem: boolean,
) =>
  isSinglePointRange && !isFirstItem
    ? startPosition + DEFAULT_SEGMENT_SIZE / 2
    : startPosition;
